import React from 'react'
import TextBlock from './TextBlock'
import ImageBlock from './ImageBlock'
import CTABlock from './CTABlock'
import ContainerBlock from './ContainerBlock'
import GridBlock from './GridBlock'
import PageHeaderBlock from './PageHeaderBlock'
import './Block.scss'

const Block = ({ block }) => {
  if (!block) return null

  const renderContent = () => {
    switch (block.BlockType) {
      case 'Text':
        return <TextBlock block={block} />
      case 'Image':
        return <ImageBlock block={block} />
      case 'CTA':
        return <CTABlock block={block} />
      case 'PageHeader':
        return <PageHeaderBlock block={block} />
      case 'Container':
        return <ContainerBlock block={block} Block={Block} />
      case 'TwoColumn':
      case 'ThreeColumn':
      case 'FourColumn':
      case 'CustomGrid':
        return <GridBlock block={block} Block={Block} />
      default:
        return null
    }
  }

  const content = renderContent()

  // If block has a link with LinkType 'Block', wrap entire block in a link
  const blockLink = block.Links && block.Links.find(link => link.LinkType === 'BlockLink')
  if (blockLink) {
    return (
      <a
        href={blockLink.Url}
        className="block-link"
        target={blockLink.IsExternal ? '_blank' : '_self'}
        rel={blockLink.IsExternal ? 'noopener noreferrer' : undefined}
      >
        {content}
      </a>
    )
  }

  return content
}

export default Block
